/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getListDialogTemplate } = actions;

export default (filters = {}, ...dependencies) => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      dispatch(getListDialogTemplate({ filters }));
    }
  }, [authReducer.isLogin, ...dependencies]);
};
